
class PlayerClick {
    
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    
    getType() {
        return 'player_click'
    }
    
    getData() {
        return {
            x: this.x,
            y: this.y
        };
    }
    
}

export default PlayerClick
